/**
 * 10DLC — website form SMS consent (Falken Design storefront).
 * Checkbox is OPTIONAL — form submits without it; consent is logged only when checked.
 * Requires window.AIBOS_SMS = { apiBase, consentSecret } in theme.liquid
 */
(function () {
  const cfg = window.AIBOS_SMS || {};
  const API_BASE = (cfg.apiBase || "https://shopify-app.falkendesign.com").replace(/\/$/, "");

  function findPhoneInput(form) {
    return (
      form.querySelector('input[type="tel"]') ||
      form.querySelector('input[name*="phone" i]') ||
      form.querySelector('input[id*="phone" i]')
    );
  }

  function findNameInput(form) {
    return (
      form.querySelector('input[name="contact[name]"]') ||
      form.querySelector('input[name*="name" i]:not([type="hidden"])')
    );
  }

  function findEmailInput(form) {
    return (
      form.querySelector('input[type="email"]') ||
      form.querySelector('input[name*="email" i]')
    );
  }

  function phoneFilled(form) {
    const phoneInput = findPhoneInput(form);
    return Boolean(phoneInput && phoneInput.value.trim());
  }

  function postConsentLog(form, block) {
    const checkbox = block.querySelector(".aibos-sms-consent__checkbox");
    if (!checkbox || !checkbox.checked) return;

    const phoneInput = findPhoneInput(form);
    const phone = phoneInput && phoneInput.value ? phoneInput.value.trim() : "";
    if (!phone) return;

    const secret = cfg.consentSecret;
    if (!secret) {
      console.warn("[AIBOS SMS] Missing consentSecret — consent not logged");
      return;
    }

    const nameInput = findNameInput(form);
    const emailInput = findEmailInput(form);
    const formType = block.getAttribute("data-form-type") || "contact";
    const disclosureEl = block.querySelector(".aibos-sms-consent__text");
    const disclosureText = disclosureEl ? disclosureEl.textContent.trim() : undefined;

    const payload = JSON.stringify({
      customer_name: nameInput ? nameInput.value : undefined,
      email: emailInput ? emailInput.value : undefined,
      phone_number: phone,
      consent_given: true,
      page_url: window.location.href,
      form_type: formType,
      consent_text: disclosureText,
    });

    fetch(API_BASE + "/api/compliance/sms-consent", {
      method: "POST",
      credentials: "omit",
      keepalive: true,
      headers: {
        "Content-Type": "application/json",
        "x-form-consent-secret": secret,
      },
      body: payload,
    }).catch(function (err) {
      console.warn("[AIBOS SMS] Consent log failed (form still submitted)", err);
    });
  }

  function wireForm(form) {
    if (form.dataset.aibosSmsWired === "1") return;

    const block = form.querySelector("[data-aibos-sms-consent]");
    if (!block) return;

    form.dataset.aibosSmsWired = "1";

    form.addEventListener(
      "submit",
      function () {
        if (!phoneFilled(form)) return;
        postConsentLog(form, block);
        // Never block submit — SMS consent is optional on Contact Us.
      },
      true,
    );
  }

  function init() {
    document.querySelectorAll("form").forEach(wireForm);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
